module.exports = __webpack_public_path__ + "img/38.d0a3cb83.jpg";